import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import { Logo } from '@/components/Logo';
import { Button } from '@/components/ui/button';
import { Sheet, SheetClose, SheetContent, SheetTitle, SheetTrigger } from '@/components/ui/sheet';
import type { Me } from '@/types/me';
import { NavGroups } from './NavGroups';
import type { NavItem } from './nav-items';
import { SidebarFooter } from './SidebarFooter';

interface MobileDrawerProps {
  items: NavItem[];
  me: Me | undefined;
}

/** Below lg (phones included): hamburger opening a left drawer with the grouped nav and the footer. */
export function MobileDrawer({ items, me }: MobileDrawerProps): JSX.Element {
  const [open, setOpen] = useState(false);
  const close = (): void => setOpen(false);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Open navigation menu" className="h-11 w-11 sm:h-9 sm:w-9">
          <Menu className="!size-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" showClose={false} aria-describedby={undefined}>
        <div className="flex h-14 shrink-0 items-center justify-between border-b border-border px-4">
          <Logo />
          <SheetClose asChild>
            <Button variant="ghost" size="icon-sm" aria-label="Close menu">
              <X />
            </Button>
          </SheetClose>
        </div>
        <SheetTitle className="sr-only">Navigation</SheetTitle>
        <div className="flex-1 overflow-y-auto px-2 py-2">
          <NavGroups items={items} onNavigate={close} />
        </div>
        {me && <SidebarFooter me={me} onNavigate={close} />}
      </SheetContent>
    </Sheet>
  );
}
